import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchBusinessEvents),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(businessEventsSaga);

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import { call, put, takeEvery } from 'redux-saga/effects';
import getJson from '../../network/get-json';
import { BUSINESS_EVENTS_FETCH_REQUESTED, BUSINESS_EVENTS_FETCH_SUCCEEDED, BUSINESS_EVENTS_FETCH_FAILED } from './actions';

function getBusinessEvents() {
  return getJson({
    url: '/businessEvents'
  });
} // worker Saga: will be fired on BUSINESS_EVENTS_FETCH_REQUESTED actions


function fetchBusinessEvents() {
  var result;
  return regeneratorRuntime.wrap(function fetchBusinessEvents$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(getBusinessEvents);

        case 3:
          result = _context.sent;

          if (!result.FailureMessageBean) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return put({
            type: BUSINESS_EVENTS_FETCH_FAILED,
            message: result.FailureMessageBean
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return put({
            type: BUSINESS_EVENTS_FETCH_SUCCEEDED,
            businessEvents: result
          });

        case 11:
          _context.next = 17;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          _context.next = 17;
          return put({
            type: BUSINESS_EVENTS_FETCH_FAILED,
            message: _context.t0.message
          });

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 13]]);
}

function businessEventsSaga() {
  return regeneratorRuntime.wrap(function businessEventsSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(BUSINESS_EVENTS_FETCH_REQUESTED, fetchBusinessEvents);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

export default businessEventsSaga;